// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hiUw","left":"styles_left__3ssHk","desktopActions":"styles_desktopActions__1eeh5","title":"styles_title__35DM8"};